<template>
    <div class="h-100 d-flex align-items-center">
      <div @click.stop="$store.commit('toggleProfile')" class="app-navbar flex-shrink-0 menu-sub-right d-flex align-items-center">
        <div class="app-profile text-right fs-8 text-gray-600 cursor-pointer" style="white-space:pre;">
          <div>{{user.userNm}} ({{user.userIdText}})</div>
          <div>{{user.email}}</div>
        </div>
        <div class="app-navbar-item ms-4">
          <div class="cursor-pointer symbol symbol-35px">
            <img :src="user.img" alt="user" onerror="this.style.display='none'">
          </div>
          <div v-if="$store.state.showProfile" class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-2 fs-6 w-250px" style="display:flex;position:absolute;right:-5px">
            <div class="menu-item flex-column flex-start px-3">
              <div class="menu-content d-flex align-items-center px-3">
                <div class="symbol symbol-50px me-5">
                  <img alt="Logo" :src="user.img" />
                </div>
                <div class="d-flex flex-column">
                  <div class="fw-bold d-flex align-items-center fs-5">{{ user.userNm }} ({{ user.userIdText }})</div>
                  <a :href="'mailto:' + user.email" class="fw-semibold text-muted text-hover-primary fs-7" v-text="user.email"></a>
                </div>
              </div>
              <div class="fw-semibold text-muted text-right fs-7 text-center" v-text="`${$t('마지막로그인')}: ${user.lastAccessDt}`"></div>
            </div>
            <div class="separator my-2"></div>
            <div class="menu-item px-5">
              <a @click="loadMyInfo('show')" class="menu-link px-5" v-text="$t('내 정보 변경')" />
            </div>
            <div class="menu-item px-5">
              <a @click="changeUserPwd" class="menu-link px-5" v-text="$t('비밀번호 변경')" />
            </div>
            <div class="menu-item px-5">
              <a @click="logout" class="menu-link px-5" v-text="$t('로그아웃')" />
            </div>
          </div>
        </div>
      </div>
  
      <template v-if="this.userInfo">
        <ModalForm id="myInfoEdit" :title="`${this.userInfo.userIdText}`" size="lg">
          <div :class="this.user.kind == 'main' ? 'emlog-print-contain' : 'emlog-print-contain adm-btline'">
            <ItemView class="mt-5" style="flex:1;" :items="this.user.kind == 'main' ? [
              {
                권한: { slot: 'roleListSlot' },
                사용자명: `${this.userInfo.userNm}`,
                연락처: `${this.userInfo.phone ? this.userInfo.phone.f('tel') : '-'}`,
                발효일: `${this.userInfo.effectDt ? this.userInfo.effectDt.f('date') : '-'}`,
                그룹: `${this.userInfo.grpNm}`,
              },
              {
                이메일: `${this.userInfo.email}`,
                사용자영문명: `${this.userInfo.userNmEn}`,
                언어: `${this.userInfo.userLangNm}`,
                사용자이미지: { slot: 'userImgSlot' },
                Product: { slot: 'productSlot' }
              },
            ] : [
              {
                권한: { slot: 'roleListSlot' },
                사용자명: `${this.userInfo.userNm}`,
                연락처: `${this.userInfo.phone ? this.userInfo.phone.f('tel') : ''}`,
                발효일: `${this.userInfo.effectDt ? this.userInfo.effectDt.f('date') : ''}`,
              },
              {
                이메일: `${this.userInfo.email}`,
                사용자영문명: `${this.userInfo.userNmEn}`,
                언어: `${this.userInfo.userLangNm}`,
                사용자이미지: { slot: 'userImgSlot' },
              },
            ]">
              <div slot="userImgSlot" class="gray-txt me-3 single-rp">
                <div class="cursor-pointer symbol symbol-30px symbol-md-40px">
                  <a v-b-modal.사용자이미지 style="color:#009ef7 !important;">{{ this.userInfo.userImgFileNm
                  }}</a><!--  :data-id="logoFileId" -->
                </div>
              </div>
              <b-form-tags slot="roleListSlot" disabled :value="this.userInfo.roleNms" />
              <b-form-tags slot="productSlot" disabled :value="this.userInfo.prodTasks" />
            </ItemView>
            <span>
              <b-button variant="light-primary" @click="modInfoAction({})" class="me-3">
                <b-icon icon="pencil" /> {{ $t('수정') }}
              </b-button>
            </span>
          </div>
  
          <template v-if="this.user.kind == 'main'">
            <div class="d-flex emlog-print-contain justify-between pb-0">
              <TableView :title="$t('개인도장')" @action="stampAction" :icon-actions="{ 'bi-pencil-fill': '개인도장수정', 'bi-trash-fill': '삭제' }"
                hidePagination @nextList="nextList" :columns="custStamp" :min-height="`48px`" :list="this.userInfo.memberStampList"
                :server-total="total" :data="stampsel" minWidth="730px" style="padding:0;">
                <b-button variant="primary" size="sm" v-b-modal.개인도장추가 v-text="$t('개인도장추가')"/>
              </TableView>
            </div>
  
            <div class="d-flex emlog-print-contain justify-between pb-0">
              <TableView :title="$t('회사도장')" @action="custStampAction" hidePagination @nextList="nextList" :data="custstampsel"
                :columns="custStamp" :min-height="`48px`" :list="this.userInfo.stampAssignList" :server-total="total" minWidth="730px"
                style="padding:0;" />
            </div>
  
            <div class="d-flex emlog-print-contain justify-between">
              <TableView :title="$t('인증서')" :icon-actions="{ 'bi-trash-fill': '인증서삭제' }" @action="remCert" hidePagination
                :list="this.userInfo.memberCertiList" :server-total="total" :columns="colCert" minWidth="730px"
                style="padding:0;" :min-height="`48px`">
                <b-button variant="primary" size="sm" v-b-modal.인증서추가 v-text="$t('인증서추가')"/>
              </TableView>
            </div>
          </template>
        </ModalForm>
  
        <b-modal lazy id="인증서추가" size="sm" centered no-close-on-backdrop hide-footer :title="this.$t('인증서 종류 선택')">
          <div class="d-flex justify-content-center flex-column" style="margin-top: -10px;">
            <b-button v-for="cd in this.$code('CERTI_TYPE')" :key="cd.value" @click="addCert(cd.value)" variant="light" block style="margin: 5px 0;">
              <img :src="cd.icon" style="height:1.4em;margin-right:0.7em">{{ cd.text }}
            </b-button>
          </div>
        </b-modal>
  
        <!-- 사용자 이미지 (프로필사진) view -->
        <b-modal id="사용자이미지" modal-class="basic" :ok-title="$t('확인')" :title="user.userImgFileNm" hide-footer centered>
          <b-embed :src="$url(user.userImgFileUrl)" allowfullscreen />
        </b-modal>
  
        <ModalForm @action="addUserStamp" id="개인도장추가" :title="$t('개인도장 추가')" :spec="custStamp" form-only :label-cols="3"
          :data="this.userInfo.memberStampList" />
        <ModalForm @action="modUserStamp" id="개인도장수정" :title="$t('개인도장 수정')" :spec="custStamp" form-only :label-cols="3"
          :data="stampsel" />
        <ModalForm id="개인view" :title="$t('개인도장')" :data="stampsel" :spec="custStamp" ok-only />
  
        <!-- <b-modal id="개인도장" modal-class="basic" :ok-title="$t('확인')" :title="stampsel.stampFileNmOrigin" hide-footer centered>
          <b-embed :src="$url(stampsel.stampFileUrl)" allowfullscreen />
        </b-modal> -->
  
        <ModalForm id="회사view" :title="$t('회사도장')" :data="custstampsel" :spec="custStamp" ok-only />
        <!-- 이미지 확대보기 -->
        <b-modal lazy modal-class="compact text-center" centered hide-footer id="stampinfo" size="sm"><img
            style="max-width:100%" :src="showStamp"></b-modal>
  
        <ModalForm id="modUserInfo" title="내 정보 수정" centered :spec="this.user.kind == 'main' ? column : colAdm"
          @action="modInfoAction" :label-cols="4" ref="editInfo" :data="this.userInfo" no-close-on-ok>
        </ModalForm>
  
        <b-modal @action="certUpdate" id="modCert" size="sm" title="인증서 수정" centered>인증서를 수정합니다.</b-modal>
      </template>
  
      <ModalForm id="changeUserPwd" title="비밀번호 변경" centered label-cols="0" form-only size="sm" no-close-on-ok :spec="[
        { key: 'pwdOld', type: 'password', placeholder: $t('기존 비밀번호')},
        { key: 'pwd', type: 'password', placeholder: $t('새 비밀번호')},
        { key: 'pwdConf', type: 'password', placeholder: $t('새 비밀번호 확인') },
      ]" ok-title="비밀번호 변경" @action="changeUserPwd"></ModalForm>
    </div>
  </template>
  
  <script>
  import ModalForm from "@/components/ModalForm.vue";
  import ItemView from "@/components/ItemView.vue";
  import TableView from "@/components/TableView.vue";
  import { inihub } from '../../config';
  const required = true;
  
  export default {
    components: { ModalForm, ItemView, TableView },
    data: () => ({
      userInfo: {},
      encPwd: '', stampsel: {}, custstampsel: {}, total: 0, showStamp: null,
      column: [
        { form: 1, key: 'roleNms', label: '권한', type: 'tag', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 2, key: 'userIdText', label: '아이디', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 3, key: 'email', type: 'email', label: '이메일', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 4, key: 'userNm', label: '사용자명', style: { textAlign: 'center' } },
        { form: 5, key: 'userNmEn', label: '사용자영문명', style: { textAlign: 'center' } },
        { form: 6, key: 'phone', label: '연락처', type: 'tel', style: { textAlign: 'center' } },
        { form: 7, key: 'userLang', label: '언어', style: { textAlign: 'center' } },
        { form: 8, key: 'effectDt', label: '발효일', type: 'date', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 10, key: 'grpNm', label: '그룹', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 11, key: 'prodTasks', label: 'Product', type: 'tag', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 12, key: 'userImgFile', label: '사용자이미지 추가', hide: ['edit', 'view', 'modStamp', 'modCert'], type: 'file', accept: ['.jpg', '.png', '.gif'], style: { textAlign: 'center' } },
        { hide: ['edit', 'view', 'modUserInfo', 'modStamp', 'modCert'], key: 'userNm', label: '조직', readonly: ['개인도장수정'] },
        { hide: ['edit', 'view', 'modUserInfo', 'modStamp', 'modCert'], key: 'grpId', label: '그룹아이디', },
        { hide: ['edit', 'view', 'modUserInfo', 'modStamp', 'modCert'], key: 'memberType', label: '멤버타입', },
      ],
      colAdm: [
        { form: 1, key: 'roleNms', label: '권한', type: 'tag', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 2, key: 'userIdText', label: '아이디', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 3, key: 'email', type: 'email', label: '이메일', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 4, key: 'userNm', label: '사용자명', style: { textAlign: 'center' } },
        { form: 5, key: 'userNmEn', label: '사용자영문명', style: { textAlign: 'center' } },
        { form: 6, key: 'phone', label: '연락처', type: 'tel', style: { textAlign: 'center' } },
        { form: 7, key: 'userLang', label: '언어', style: { textAlign: 'center' } },
        { form: 8, key: 'effectDt', label: '발효일', type: 'date', readonly: ['modUserInfo'], style: { textAlign: 'center' } },
        { form: 9, key: 'userImgFile', label: '사용자이미지 추가', hide: ['edit', 'view', 'modStamp', 'modCert'], type: 'file', accept: ['.jpg', '.png', '.gif'], style: { textAlign: 'center' } },
      ],
      custStamp: [   //  개인도장 리스트
        { key: 'stampType', label: '종류', form: 1, required, default: 1, options: [{ text: '도장', value: 1 }, { text: '서명', value: 2 }], type: 'radio', renderer: item => `${item.stampType == 1 ? '도장' : '서명'}`, style: { textAlign: 'center' } },
        { key: 'stampNm', label: '도장명', form: 2, required, style: { textAlign: 'center' } },
        { key: 'stampTypeNm', hide: ['td', '개인도장추가', '개인도장수정', 'view'], label: '도장명', required, style: { textAlign: 'center' } },
        { key: 'stampFile', label: '도장', hide: ['view'], renderer: (item, s) => `<img data-id="${item.stampFileId}" src="${s.$url(item.stampFileUrl)}" allowfullscreen style="max-height:64px; cursor:pointer" onerror="this.style.display='none'"/>`, type: 'sign', accept: ['.jpg', '.png', '.gif'], style: { textAlign: 'center' } },
        { key: 'stampFileNmOrigin', label: '도장', form: 3, hide: ['td', '개인도장추가', '개인도장수정'], style: { textAlign: 'center' }, },
      ],
      colCert: [   //  인증서 리스트
        { label: '상태', renderer: i=>`<b class="badge fs-7 badge-light-${i.certiStatusClass}">${i.certiStatusNm}</b>`, style: { textAlign: 'center' } },
        { key: 'certiTypeNm', label: '종류', style: { textAlign: 'center' } },
        { key: 'idn', label: '인증서', style: { textAlign: 'center' } },
      ],
      stamps: [
        { label: '도장/서명 추가', form: 1, key: 'docFile', type: 'file', accept: '.pdf' },
      ],
    }),
    computed: {
      user() { return this.$store.state.user },
    },
    created() {
      this.userInfo = this.$store.state.user;
      this.column.getCol('userLang').options = this.$code('LANG');
      this.colAdm.getCol('userLang').options = this.$code('LANG');
    },
    methods: {    
      nextList() { if (this.total > this.list.length) this.getList(this.list.length + 1); },
      async addCert(certiType) {// C_FIN, C_JOINT, P_FIN, P_JOINT
        await this.$loadScript('/libs/inihub.js');
        const { clientId:inihubClientIds, baseUrl } = inihub, type = certiType.charAt(2)=='F'?'kftc':'pblc_cwui', clientId = inihubClientIds[certiType.charAt(0)=='C'?1:0];
        await window.IHUB_C.init({ type, baseUrl: baseUrl||location.origin, clientId });
        this.$bvModal.hide('인증서추가');
        try {
          let res = await window.IHUB_C.login({ type, clientId });
          if (this.devMode) console.log('IHUB_C.login', res);
          if (res.resCode != 1200) return this.$alert(res.errorMessage, { title: 'IHUB_C.login' });
          res = await this.$api('main/insertMemberCerti', {certiType, authToken:res.authToken});
          this.$alert(res.msg);
          if (res.success) this.loadMyInfo();
        }
        catch (e) {
          console.log('IHUB_C.login', e);
          this.$alert(e.errorMessage);
        }
      },
      async remCert({item}) {
        if (!(await this.$alert(this.$t('삭제하시겠습니까?'), {confirm:true}))) return;
        const {userId, certiSeq} = item;
        const res = await this.$api('main/deleteMemberCerti', {userId, certiSeq});
        this.$alert(res.msg);
        if (res.success) this.loadMyInfo();
      },
      async logout() {
        try {
          await this.$api('logout', {}, { errors: { 401: '' } });
        } catch (e) { console.log(e) }
        this.$store.commit('user');
      },
      async changeUserPwd({ form }) {
        if (form) {
          const rsaEnc = await this.$rsaEnc([form.pwd, form.pwdConf, form.pwdOld]);
          const resUserPwd = await this.$api('adm/changeUserPwd', { pwd: rsaEnc[0], pwdConf: rsaEnc[1], pwdOld: rsaEnc[2] })
          this.$alert(resUserPwd.msg.replace(/\n/g, '<br />'));
          if (resUserPwd.success) this.$bvModal.hide("changeUserPwd");
        }
        else this.$bvModal.show('changeUserPwd');
      },
      /* 로그인 한 user 데이터  */
      async loadMyInfo(param) {
        this.userInfo = {}; // 항상 새로 조회해오도록 사용자 정보 객체 초기화
  
        if (param == 'show') {
          this.encPwd = ''; // 새로 띄었을 경우 가지고 있는 암호화 된 사용자 비밀번호 초기화
  
          let count = 0;
          while(count++ < 5) {
            setTimeout(() => document.querySelector('#pwd_check_input').focus(), 100);
            if (!(await this.$alert(`<input maxlength=100 id="pwd_check_input" placeholder="${this.$t('비밀번호')}" class="form-control" type="password">`, { confirm: true, title: this.$t('비밀번호 확인') }))) {
              return;
            } else {
              if(window.pwd_check_input.value == '') {
                await this.$alert(this.$t('비밀번호를 입력하세요'));
                continue;
              }
              
              const rsaEnc = await this.$rsaEnc([window.pwd_check_input.value]);
              let result = await this.$api((this.user.kind == 'main' ? 'main/selectLoginMember' : 'adm/selectLoginUser'), { masking: false, searchKeyword: this.searchKeyword, pwd: rsaEnc[0] });
              if (!result.success) {
                await this.$alert(result.msg);
                continue;
              } else {
                this.userInfo = result.data;
                this.encPwd = rsaEnc[0];
                break;
              }
            }
          }
        } else {
          let result = await this.$api((this.user.kind == 'main' ? 'main/selectLoginMember' : 'adm/selectLoginUser'), { masking: false, searchKeyword: this.searchKeyword, pwd: this.encPwd });
  
          if (!result.success) {
            await this.$alert(result.msg);
            return;
          } else {
            this.userInfo = result.data;
          }
        }
        
        if(this.userInfo) {
          this.$bvModal.show('myInfoEdit');
        }
      },
      //개인도장 Action
      async stampAction({ action, item, form }) {
        if (['개인도장수정'].includes(action)) {
          this.stampsel = item;
          this.$bvModal.show('개인도장수정');
        }      
        else if (['삭제'].includes(action)) {
          this.stampsel = item;
          const stampSeq = this.stampsel.stampSeq;
          const userId = this.stampsel.userId;
          if (!form && !(await this.$alert(this.$t('[$] 도장을 삭제 하시겠습니까?', [item.stampNm]), { confirm: true, title: action }))) return;
          const res = await this.$api('main/deleteMemberStamp', { form, userId, stampSeq });
          this.$alert(res.msg);
          if (res.success) this.loadMyInfo();
        }
        
        return;
      },
      // 개인도장 추가
      async addUserStamp({ form }) {
        form.append('userId', this.user.userId);
        const res = this.$api('main/insertMemberStamp', form);
        res.then(data => {
          this.$alert(data.msg);
          if (data.success) this.loadMyInfo();
        }).catch(error => console.log(error));
        // await this.$alert(res.msg);
      },
      async certAction({ action, form }) {
        if (!form && ['인증서수정'].includes(action)) {
          this.$bvModal.show('modCert');
          return;
        }
      },
      //회사도장 Action
      async custStampAction({ action, form, item, event }) {
        console.log({ action, form, item, event });
        return;
      },
      //내정보 수정
      async modInfoAction({ form }) {
        if (!form) return this.$bvModal.show('modUserInfo');
        if (form.get('userImgFile')) form.delete('userImgFileId');
        form.append('encPwd', this.encPwd);
        const updateUserRes = await this.$api('cmm/updateLoginUser', form);
        if (updateUserRes.success) {
          const user = updateUserRes.data;
          this.$setCodes(user.userLang);
          delete user.auths;
          user.img = this.$url(user.userImgFileUrl);
          const lang = form.get('userLang');
          if (lang && (this.$store.state.settings.lang != lang)) await this.$store.commit('settings', { lang });
          user.img = user.userImgFileUrl ? this.$url(user.userImgFileUrl) : '/img/user.webp';
          user.custId = this.user.custId;
          await this.$store.commit('user', user);
          this.$bvModal.hide("modUserInfo");
        }
        await this.$alert(updateUserRes.msg); this.loadMyInfo();
      },
      //내정보 인증서 수정
      async certUpdate() { },
      //내정보 도장 수정
      async modUserStamp({ form }) {
        if (form.get('stampFile')) form.delete('stampFileId');
        form.append('stampSeq', this.stampsel.stampSeq);
        form.append('userId', this.stampsel.userId);
        const res = await this.$api('main/updateMemberStamp', form);
        await this.$alert(res.msg); this.loadMyInfo();
      },
    }
  }
  </script>